/**
 * Build a venue's display label from its project and product names.
 *
 * Product names are usually project-prefixed (e.g. "Uniswap V4"), so prepend
 * the project only when the product does not already start with it, avoiding
 * both "Uniswap Uniswap V4" AND the redundant "Uniswap V4 (Uniswap)" that
 * overflowed the venue legend. A venue with no resolved product name falls
 * back to the project name, then the caller-supplied fallback, never a bare
 * id slug.
 */
export function formatVenueLabel(
  projectName: string | null | undefined,
  productName: string | null | undefined,
  fallback = "",
): string {
  const product = productName || ""
  const project = projectName || ""
  if (product) {
    if (!project) return product
    return product.toLowerCase().startsWith(project.toLowerCase())
      ? product
      : `${project} ${product}`
  }
  return project || fallback
}
